import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { EmailTemplateKey, EmailTemplateResponse, UpdateEmailTemplateInput } from '@orion/contracts';
import { api } from '../../../lib/api-client.js';

const KEY = ['admin-email-templates'];

export function useEmailTemplatesQuery() {
  return useQuery({ queryKey: KEY, queryFn: () => api.get<EmailTemplateResponse[]>('/admin/email-templates') });
}

export function useUpdateEmailTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, input }: { key: EmailTemplateKey; input: UpdateEmailTemplateInput }) =>
      api.put<EmailTemplateResponse>(`/admin/email-templates/${key}`, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}

export function useResetEmailTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (key: EmailTemplateKey) => api.post<EmailTemplateResponse>(`/admin/email-templates/${key}/reset`, {}),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
